import { Component } from "react";
import { TYPING_TIMEOUT } from "../../../constants";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import TextFieldWithTypingTimeout from "../../Input/TextFieldWithTypingTimeout";

class InterventionTextField extends Component {
    constructor(props) {
        super(props);

        let defaultValue = this.props.value.value_text;

        if (this.props.type === "number") defaultValue = this.props.value.value_float;

        this.state = {
            value: defaultValue,
            timeout: TYPING_TIMEOUT,
            typedJustNow: false,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (state.typedJustNow) return state;

        let currentValue = props.value.value_text;

        if (props.type === "number") currentValue = props.value.value_float;

        state.value = currentValue;
        return state;
    }

    handleChange(value) {
        let fieldValue = this.props.value;

        if (this.props.type === "number") fieldValue.value_float = value;
        else fieldValue.value_text = value;

        this.props.fieldValueChange(fieldValue);

        this.setState({
            typedJustNow: false,
        });
    }

    onClick = (ev) => {
        const el = ev.target;
        if (document.activeElement !== el) {
            setTimeout(() => {
                if (el.select) el.select();
            }, 0);
        }
    };

    render() {
        console.perfLog(getCurrentFunctionName());
        return (
            <TextFieldWithTypingTimeout
                onValueChange={this.handleChange.bind(this)}
                label={this.props.model.name}
                {...this.props.inputProperties}
                type={this.props.type}
                value={this.state.value}
                multiline={this.props.multiline}
                className={this.props.inputProperties.className + " full_size control-margin-top"}
                onMouseDown={this.props.type === "number" ? this.onClick : null}
            />
        );
    }
}

export default InterventionTextField;
